import ToggleButton from '@mui/material/ToggleButton';
import Tooltip from '@mui/material/Tooltip';
import { FC, ReactNode } from 'react';

type ToolbarBtnProps = {
  children: ReactNode;
  tooltip: string;
  active: boolean;
  onClick: () => void;
  disabled?: boolean;
};

export const ToolbarBtn: FC<ToolbarBtnProps> = ({ children, tooltip, active, onClick, disabled }) => (
  <Tooltip title={tooltip}>
    <ToggleButton
      value={tooltip}
      size="small"
      selected={active}
      disabled={disabled}
      onMouseDown={e => e.preventDefault()}
      onClick={onClick}
      sx={{ minWidth: 32, height: 28, fontSize: 12, fontWeight: 600, px: 1, border: 0 }}
    >
      {children}
    </ToggleButton>
  </Tooltip>
);
